<template>
    <div class="card" v-on="$listeners">
        <template v-if="collapsable">
            <div class="card-header">
                <TitleComponent v-b-toggle="'collapse-' + name">
                    <template slot="title">
                        {{title}}
                    </template>
                </TitleComponent>

                <template v-if="tools">
                    <div class="card-tools">
                        <template v-for="(tool, index) in tools">
                            <i
                                :key="index"
                                class="p-2"
                                :class="[{ 'text-red' : mode == tool.mode }, tool.icon]"
                                aria-hidden="true"
                                @click.prevent="() => {mode = tool.mode; $emit('changeMode', tool.mode)}"
                            ></i>
                        </template>
                    </div>
                </template>
            </div>
        </template>
        <template v-else>
            <div class="card-header">
                <TitleComponent>
                    <template slot="title">
                        {{title}}
                    </template>
                </TitleComponent>
                <div class="flex-grow-1 text-right">
                    <slot name="actions"></slot>
                </div>
            </div>
        </template>

        <component :is="collapsable ? 'b-collapse' : 'div'" :id="'collapse-' + name" class="mt-2">
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </component>

    </div>
</template>

<script>
    import TitleComponent from './eventos/components/TitleComponent';

    export default {
        props: ['name', 'title', 'collapsable', 'tools'],
        data() {
            return {
                mode: 'informe'
            }
        },
        components: {
            TitleComponent
        }
    }
</script>

<style>

</style>
